import React from 'react'
import SavingImg1 from '../../Images/SavingImg/LoanpaymentSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const LoanPaymentSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>ऋण भुक्तानी बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>ऋण प्राप्त गर्ने समयमा बचत खाता सञ्चालन गर्नुपर्ने ।</li>
                                        <li>ऋणको साँवा तथा ब्याज भुक्तानी गर्न ।</li>
                                        <li>सेयरमा सहभागितास्तर अनुपात नपुगेको भए नपुगे जति रकम सेयर खरिद गर्नु पर्ने ।</li>
                                        <li>सेयरमा सहभागितास्तर अनुपात पुगेको भए यस बचत खातामा रकम राखिने ।</li>
                                        <li>दैनिक बचत गरी ऋण किस्ता तिर्न बचत जम्मा गरेमा यस बचत खातामा रकम राखि तिर्न सकिने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने ।</li>
                                        <li>यस प्रकारका बचतमा ऋण रकमको २.५% रकम जम्मा गर्नुपर्ने ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default LoanPaymentSaving